import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState,} from 'react'
import {useLocation} from 'react-use'
import {NullAsDefault} from 'views/Shared'
import _ from "lodash";
import {catholicHousehold_fetchChangeLogs_Api} from "../../../../apis/catholicHousehold";
import {renderCatholicHouseholdLog} from "../functions/renderCatholicHouseholdLog";
import usePaginationHelper, {createPagerKey} from "../../../AppLocals/hooks/usePaginationHelper";
import {bindQueryParam} from "../../../AppLocals/functions/routerHelper";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {LuListRestart} from "react-icons/lu";

const CatholicHouseholdChangeLogs = ({
                                       item,
                                       Wrapper = 'div',
                                       filter_actions = {
                                         sortBy: 'sort-by',
                                         keyword: 'keyword'
                                       },
                                     }) => {

  const t = useTranslate()
  const location = useLocation()

  const [refreshKey, setRefreshKey] = useState()
  const sortBy = useRouteSearchParam(filter_actions.sortBy)

  const refresh_deps = useMemo(
    () => [
      refreshKey,
      `refreshToken=${_.get(location.state, 'refreshToken')}`,
    ],
    [refreshKey, location.state]
  )

  const [pager_widget] = usePaginationHelper({
    sortHeader: null,
    SortByWidget: NullAsDefault,
    renderFilter: NullAsDefault,
    isToggleDefault: true,
    AdvancedFilter: NullAsDefault,
    withValues: (values) => ({
      ...values,
    }),
    query_params: filter_actions,
    withKey: createPagerKey(refresh_deps),
    pagerInfo: {
      RenderEntity: React.Fragment,
      query: bindQueryParam({id: item?.id}),
      PaginationMeta: NullAsDefault,
      apiInfo: catholicHousehold_fetchChangeLogs_Api,
      renderItem: renderCatholicHouseholdLog,
      renderWrap: (child) => (
        <div className="flex flex-col gap-2 ml-4">
            {child}
        </div>
      )
    },
    onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
      onSortChange(sortBy)
      onFilterChange({})
    },
    filter_params: {},
    dependencies: [],
    renderHeader: ([searchBar, filterBar]) => (
      <div className="flex flex-col">
          <div className="flex items-center gap-2">
              <LuListRestart size={16} className="text-blue-300"/>
              <span className="font-bold text-blue-500 uppercase tracking-wider">
                  {t('changed information')}
              </span>
          </div>
      </div>
    ),
  })

  return (
      <Wrapper className="p-2 flex flex-col gap-1 border border-blue-300 rounded-lg bg-orange-50">
          {pager_widget}
      </Wrapper>
  )
}


export default CatholicHouseholdChangeLogs
